<template>
    <div>
        <Modal :show="showModal" :close="() => {}">
            <template #header>
                <h1 class="header">{{ $t("modal.same-as-cash.header") }}</h1>
            </template>

            <template #body>
                <div class="body-text">{{ $t("modal.same-as-cash.body") }}</div>
            </template>
            <template #footer>
                <div class="text-right">
                    <button id="same-as-cash-confirm-btn" class="confirm-button" @click="closeModal(true)">
                        Got it
                    </button>
                    <button id="same-as-cash-cancel-btn" class="cancel-button" @click="closeModal(false)">Back</button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"

    export default {
        name: "SameAsCash",
        components: {
            Modal,
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            closeModal(confirm) {
                this.$emit("close-confirm-modal")
                if (confirm === true) {
                    this.$emit("same-as-cash-confirm")
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .confirm-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
        color: $secondary-color;
    }

    .cancel-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
    }
</style>
